import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Form, Input, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { useDelayed } from '../../../hooks/useDelayed';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { Hint } from '../../../_lib/components/Hint';

export type EmailVerificationFormTypes = TextParam<'emailAddress'>;

type EmailVerificationFormProps = {
  form: SonForm<EmailVerificationFormTypes>;
};

export function EmailVerificationForm({ form }: EmailVerificationFormProps) {
  const { t } = useSonTranslation('PersonExtendedData');
  const id = useHtmlValidId();

  const { refresh } = useRefreshBlock();
  const { closeModal } = useModalContext();
  const delayedRefreshAndClose = useDelayed(() => {
    refresh();
    closeModal();
  });

  const { formProps, fetchState, params } = useForm({ form, onSuccess: delayedRefreshAndClose });

  const emailAddressParam = params.findByName('emailAddress');

  return (
    <Form {...formProps} id={`email-verification-form-${id}`}>
      <Row>
        <Hint message={t('changeEmail.hint')} />
      </Row>
      <Row>{emailAddressParam && <Input label={t('changeEmail.email')} param={emailAddressParam} />}</Row>
      <SubmitButton
        buttonLabel={t('changeEmail.submit')}
        messageSuccess={t('changeEmail.status.success')}
        messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
        messageFail={t('phrases:changesCouldNotBeSaved')}
        fetchState={fetchState}
        customErrorTypeMessages={{
          itemAlreadyExists: t('changeEmail.errorType.itemAlreadyExists'),
        }}
      />
    </Form>
  );
}
